<template >
  <!-- Collect the nav links, forms, and other content for toggling -->
  <div class="collapse navbar-collapse main-navigation mainmenu " id="main-nav-bar">

<ul class="nav navbar-nav navigation-box ps-0 pe-4">
    <li> <router-link to="/contact-us">درباره ما</router-link> </li>
    <li> <router-link to="/wage">کارمزد</router-link> </li>
    <li><router-link to="/rules">قوانین</router-link>
       
    </li>
    <li> <router-link to="/help">راهنمای استفاده</router-link>
        

    </li>
    <li> 
        <a href="http://blog.ataxc.com">وبلاگ</a>

    </li>
    <li><router-link to="/">خانه</router-link> </li>
</ul>
</div><!-- /.navbar-collapse -->
</template>
<script>
export default {
    
}
</script>
<style >
    
</style>